import { gql } from "@apollo/client"

const FIREBASE_STUDENT = `
  id
  firstName
  lastName
  fullName
  email
  username
  validated
  role
  created
  createdBy
  lastModified
  state
  schoolDistrict
  school
  grade
  externalStudentId
  teachers
  classes {
    id
    name
  }
  classesCount
  hasActiveLicense
  licensePools
  licenseOrgType
  licenseOrgId
  licenseOrgName
  assessments
  activity
  sfid
  deleted
  timeAccomodation {
    customTime {
      settings {
        value
      }
      enabled
    }
    doubleTime {
      settings {
        value
      }
      enabled
    }
    noTimingAccomdations {
      settings {
        value
      }
      enabled
    }
    timeAndHalf {
      settings {
        value
      }
      enabled
    }
    unlimitedTime {
      settings {
        value
      }
      enabled
    }
  }
`

const FIREBASE_EDUCATOR = `
  id
  created
  createdBy
  lastModified
  firstName
  lastName
  fullName
  email
  username
  validated
  role
  isTeacher
  state
  schoolDistrict
  school
  classes
  licenses
  assessments
  activity
  title
  sfid
  deleted
  sourceId
  emailNotification
  schools
  districts
`

export const GET_ORG_STUDENTS = gql`
  query getListWithCreatorsByOrgRefScope(
    $data: GetStudentsByOrgRefScopeInput!
  ) {
    student {
      getListWithCreatorsByOrgRefScope(data: $data) {
        students {
          ${FIREBASE_STUDENT}
        }
        creators {
          ${FIREBASE_EDUCATOR}
        }
      }
    }
  }
`

export const GET_LICENSED_PROGRAMS_AND_PRODUCTS = gql`
  query getLicensedProgramsAndProducts {
    getLicensedProgramsAndProducts {
      program
      category
      programInfo {
        useGradelevels
        supportStudyPlan
        canTeachLive
        useDiagPracticeTest
        useTestTimingSetting
        defaultTestTimingValue
        displayName
      }
      products
    }
  }
`

export const GET_ORG_STUDENTS_COUNT = gql`
  query getCountByOrgRefScope($data: GetStudentsByOrgRefScopeInput!) {
    student {
      getCountByOrgRefScope(data: $data) {
        count
      }
    }
  }
`

export const GET_STUDENT = gql`
  query getStudent($id: String!, $orgRefScope: OrgRefScope!) {
    student {
      get(id: $id, orgRefScope: $orgRefScope) {
        id
        firstName
        lastName
        email
        username
        grade
        schoolId
        districtId
      }
    }
  }
`

export const GET_FIREBASE_STUDENT = gql`
  query getFirebaseStudent($data: GetStudentsPagedInput!) {
    student {
      getPagedListByOrgRefScope(data: $data) {
        students {
          ${FIREBASE_STUDENT}
        }
        paginationMeta {
          totalCount
        }
      }
    }
  }
`

export const GET_STUDENT_LIST_BY_ORG_REF_SCOPE = gql`
  query getStudentListByOrgRefScope($data: GetStudentsByOrgRefScopeInput!) {
    student {
      getStudentListByOrgRefScope(data: $data) {
        id
        firstName
        lastName
      }
    }
  }
`

export const GET_ORG_STUDENTS_PAGED_WITHOUT_CREATORS = gql`
  query getPagedListByOrgRefScope(
    $data: GetStudentsPagedInput!
  ) {
    student {
      getPagedListByOrgRefScope(data: $data) {
        students {
          ${FIREBASE_STUDENT}
        }
        paginationMeta {
          totalCount
          page
          pageSize
          hasNextPage
          hasPrevPage
        }
      }
    }
  }
`

export const GET_ORG_STUDENTS_PAGED = gql`
  query getPagedListWithCreatorsByOrgRefScope(
    $data: GetStudentsPagedInput!
  ) {
    student {
      getPagedListWithCreatorsByOrgRefScope(data: $data) {
        students {
          ${FIREBASE_STUDENT}
        }
        creators {
          ${FIREBASE_EDUCATOR}
        }
        paginationMeta {
          totalCount
          page
          pageSize
          hasNextPage
          hasPrevPage
        }
      }
    }
  }
`

export const GET_STUDENT_REPORTING_VIEW_DETAILS = gql`
  query getReportingViewDetails(
    $id: String!
    $orgRefScope: OrgRefScopeOptional!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    student {
      getReportingViewDetails(
        id: $id
        orgRefScope: $orgRefScope
        startDate: $startDate
        endDate: $endDate
      ) {
        id
        firstName
        lastName
        externalStudentId
        email
        username
        grade
        schoolId
        districtId
        schoolName
        isActive
        createdAt
      }
    }
  }
`
